import React, { useMemo } from 'react';
import './AgentTools.css';
import { useSelector } from 'react-redux';
import { useTable, usePagination } from 'react-table';

const ReferredList = () => {
  const referredList = useSelector(state => state.referral.referredList);
  const data = useMemo(() => referredList, [referredList]);
  const columns = useMemo(
    () => [
      {
        Header: 'ID',
        accessor: '_id', // accessor is the "key" in the data
      },
      {
        Header: 'Username',
        accessor: 'username',
      },
      {
        Header: 'Register Date',
        accessor: 'createdAt',
      },
    ],
    [],
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    usePagination,
  );

  return (
    <>
      <table {...getTableProps()} className="generalTable">
        <thead>
          {headerGroups.map(headerGroup => (
            // eslint-disable-next-line react/jsx-key
            <tr {...headerGroup.getHeaderGroupProps()}>
              <th>#</th>
              {headerGroup.headers.map(column => (
                // eslint-disable-next-line react/jsx-key
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);

            return (
              // eslint-disable-next-line react/jsx-key
              <tr {...row.getRowProps()}>
                <td>{i + 1 + pageSize * pageIndex}</td>
                {row.cells.map(cell => {
                  // eslint-disable-next-line react/jsx-key
                  if (cell.column.id === 'createdAt') {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                  } else {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {pageOptions && pageOptions.length > 1 && (
        <div className="pagination">
          <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            {'<<'}
          </button>{' '}
          <button onClick={() => previousPage()} disabled={!canPreviousPage}>
            {'<'}
          </button>
          {'    '}
          <span className="pageCount">
            Page{' '}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>
            {'    '}
          </span>
          <button onClick={() => nextPage()} disabled={!canNextPage}>
            {'>'}
          </button>{' '}
          <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            {'>>'}
          </button>{' '}
          {/* <span>
          | Go to page:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              gotoPage(page);
            }}
            style={{ width: '100px' }}
          />
        </span>{' '} */}
          {/* <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select> */}
        </div>
      )}
    </>
  );
};

export default ReferredList;
